module.exports = __webpack_public_path__ + "img/crew_labor.b5681b73.svg";